// jQuery free
import {effectShakeElement} from './effects';
import searchAutocomplete from './searchAutocomplete';
import {onDOMReady} from './dom';

onDOMReady(() => {
    const searchForm = document.getElementById('layoutHeaderSearch');
    if (!searchForm) {
        return;
    }

    const searchInput = document.getElementById('layoutHeaderSearch__input');
    if (!searchInput) {
        return;
    }

    searchForm.onsubmit = (event) => {
        searchInput.value = searchInput.value.trim().replace(/\s/g, ' ');
        if (searchInput.value.length < 2) {
            event.preventDefault();
            effectShakeElement(searchForm);
        }
    };

    searchAutocomplete({searchForm, searchInput});

    const searchPhrase = window.KMPayload?.searchPhrase;
    if (searchPhrase) {
        searchInput.value = searchPhrase;
    }
});